import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { PhotoLightboxService } from '../../../core/services/photo-lightbox.service';

/**
 * Renders a single photo thumbnail that opens a PhotoSwipe lightbox on click.
 * When there are multiple photos, a small count badge overlays the thumbnail corner.
 * Clicking anywhere on the thumbnail opens the full gallery.
 *
 * Usage (single photo):   <app-photo-thumbnail [photos]="[photoUrl]" />
 * Usage (multi-photo):    <app-photo-thumbnail [photos]="photoUrls" />
 */
@Component({
  selector: 'app-photo-thumbnail',
  standalone: true,
  imports: [],
  templateUrl: './photo-thumbnail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './photo-thumbnail.component.css',
})
export class PhotoThumbnailComponent {
  /** Array of data URLs or blob URLs to display */
  photos = input<string[]>([]);

  private lightbox = inject(PhotoLightboxService);

  hasMultiple = computed(() => this.photos().length > 1);

  openLightbox(): void {
    this.lightbox.openMultiple(this.photos(), 0);
  }
}
